import React, {useEffect, useRef, useState} from 'react';
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import {Modal} from "../../../../components/modal/modal.jsx"
import Button from "../../../../components/button/button.jsx";
import html2canvas from "html2canvas";
import PrintHeader from "../../../../components/reports/print-reports/print-header.jsx";
import PrintFooter from "../../../../components/reports/print-reports/print-footer.jsx";
import "../../../../css/style-report.css"
import PrintTemplate from "../../../../components/reports/print-reports/print-template.jsx";

const Print = ({setIsPrinting, isPrinting, setIsLoading, filters, itemsByLayers, itemsByPeriod, layers, subtitles, markers, showModalPrint, markerTarget, setShowModalPrint, mapRef, headerSelected}) => {
    const [periodCheck, setPeriodCheck] = useState(false);
    const [layerCheck, setLayerCheck] = useState(false);
    const [subtitlesCheck, setSubtitlesCheck] = useState(false);
    const printComponentRef = useRef(null);

    useEffect(() => {
        markerTarget?.setAnimation(null);
    }, [print]);

    const windowPrint = async () => {
        setIsLoading(true)
        setIsPrinting(true);
        setShowModalPrint(false);
        await new Promise(resolve => setTimeout(resolve, 100));

        document.querySelectorAll(".print-none").forEach(element => element.classList.add("d-none"));
        document.querySelector(".gm-fullscreen-control").classList.add("d-none");
        document.querySelectorAll(".gmnoprint").forEach(element => element.classList.add("d-none"));
        document.querySelectorAll(".gm-style-iw-tc").forEach(element => element.classList.add("d-none"));
        document.querySelectorAll(".gm-style-iw").forEach(element => element.classList.add("d-none"));

        window.onafterprint = function () {
            document.querySelectorAll(".print-none").forEach(element => element.classList.remove("d-none"));
            document.querySelector(".gm-fullscreen-control").classList.remove("d-none");
            document.querySelectorAll(".gmnoprint").forEach(element => element.classList.remove("d-none"));
            document.querySelectorAll(".gm-style-iw-tc").forEach(element => element.classList.remove("d-none"));
            document.querySelectorAll(".gm-style-iw").forEach(element => element.classList.remove("d-none"));
        };

        html2canvas(mapRef.current, {
            allowTaint: true,
            useCORS: false,
        }).then(canvas => {
            document.getElementById('mapSnapshot').appendChild(canvas).classList.add('mapCanvas');

            printComponentRef.current?.print()
        });
    }

    const afterPrint = () => {
        setPeriodCheck(false);
        setLayerCheck(false);
        setSubtitlesCheck(false);

        markerTarget?.setAnimation(google.maps.Animation.BOUNCE);
        setIsPrinting(false)
    }

    const closeModal = () => {
        setShowModalPrint(false);
        setPeriodCheck(false);
        setLayerCheck(false);
        setSubtitlesCheck(false);

        markerTarget?.setAnimation(google.maps.Animation.BOUNCE);
    };

    return (
        <div className="">
            <Modal open={showModalPrint} setOpen={closeModal} centered size="md" backdrop="static"
                   title={"Opções de impressão"} keyboard={false} className={"w-5/12 print:hidden"}>
                <Modal.Body>
                    <h4 className={"mb-2"}>Incluir no relatório:</h4>
                    <InputCheckbox
                        className={"mb-2"}
                        id={"item-by-period"}
                        label={"Relação de itens por período"}
                        checked={periodCheck}
                        onChange={() => setPeriodCheck(!periodCheck)}
                        disabled={!markers.size}
                    />
                    <InputCheckbox
                        className={"mb-2 analysis-checkbox"}
                        id={"item-by-layer"}
                        label={"Relação de itens por setor"}
                        checked={layerCheck}
                        onChange={() => setLayerCheck(!layerCheck)}
                        disabled={!layers.size}
                    />
                    <InputCheckbox
                        className="analysis-checkbox"
                        id={"subtitles"}
                        label={"Legenda"}
                        checked={subtitlesCheck}
                        onChange={() => setSubtitlesCheck(!subtitlesCheck)}
                        disabled={!markers.size}
                    />
                </Modal.Body>

                <Modal.Footer className={"p-2"}>
                    <div className={"w-full flex justify-end m-0 gap-2"}>
                        <Button onClick={windowPrint}>
                            Imprimir
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>

            {
                isPrinting &&
                <PrintTemplate
                    title={"Análise georreferenciada"}
                    entity={headerSelected}
                    ref={printComponentRef}
                    setIsPrinting={setIsLoading}
                    onAfterPrint={afterPrint}
                >
                    <div>
                        <div className="print-filters transform !-translate-y-[8.5px]">
                            <span>Filtros: {filters}</span>
                        </div>
                        <div className="print:border-b print:border-gray-200 print:mb-6 print:w-full"/>
                        <div id="mapSnapshot"></div>

                        {
                            periodCheck &&
                            <>
                                <div id="print-period-table">
                                    <h3 className="mt-2">Itens por período</h3>
                                    <div dangerouslySetInnerHTML={{__html: itemsByPeriod}}></div>
                                </div>
                            </>
                        }

                        {
                            layerCheck &&
                            <>
                                <div id="print-sector-table">
                                    <h3 className="mt-2">Itens por setor</h3>
                                    <div dangerouslySetInnerHTML={{__html: itemsByLayers}}></div>
                                </div>
                            </>
                        }

                        {
                            subtitlesCheck &&
                            <>
                                <div id="print-subtitles-table">
                                    <h3 className="mt-2">Legenda</h3>
                                    <div dangerouslySetInnerHTML={{__html: subtitles}}></div>
                                </div>
                            </>
                        }
                    </div>
                </PrintTemplate>
            }
        </div>
    );
};

export default Print;
